import { useDispatch } from 'react-redux';
import { applyPromoCode, resetPromoCode, setEmailCoupon, validatePromoCode } from 'State/PromoCode/PromoCodeActions';

export const usePromoCode = () => {
  const dispatch = useDispatch();
  const validateCoupon = (code) => dispatch(validatePromoCode(code));
  const resetCoupon = () => dispatch(resetPromoCode());
  const emailCoupon = (code) => dispatch(setEmailCoupon(code));
  const applyCoupon = (code) => dispatch(applyPromoCode(code));

  return {
    applyCoupon,
    emailCoupon,
    resetCoupon,
    validateCoupon,
  };
};
